module.exports = __webpack_public_path__ + "img/logo_blanco.e761e01c.png";